import type { ChartSetting } from "shared/modules/Charts/types";
import { isChartSettingWithOptionalLinkedSocialStreams } from "shared/modules/Charts/types/guards";

export function getChartSettingWithMovedMentionStreamDependencies<
  TChartSetting extends ChartSetting,
>(
  chartSetting: TChartSetting,
  previousMentionStreamId: number,
  nextMentionStreamId?: number
): TChartSetting {
  const updatedChartSetting = { ...chartSetting };

  if (isChartSettingWithOptionalLinkedSocialStreams(updatedChartSetting)) {
    updatedChartSetting.linked_stream_ids = moveStreamKeyedValue(
      updatedChartSetting.linked_stream_ids ?? {},
      previousMentionStreamId,
      nextMentionStreamId
    );
  }

  return updatedChartSetting;
}

export function getChartSettingWithClearedMentionStreamDependencies<
  TChartSetting extends ChartSetting,
>(chartSetting: TChartSetting): TChartSetting {
  const updatedChartSetting = {
    ...chartSetting,
    advanced_filters: null,
  };

  if (isChartSettingWithOptionalLinkedSocialStreams(updatedChartSetting)) {
    updatedChartSetting.linked_stream_ids = {};
  }

  return updatedChartSetting;
}

function moveStreamKeyedValue<TValue>(
  values: Record<string, TValue>,
  previousStreamId: number,
  nextStreamId?: number
): Record<string, TValue> {
  const updatedValues = { ...values };
  const value = updatedValues[previousStreamId];

  delete updatedValues[previousStreamId];

  if (nextStreamId && value !== undefined) {
    updatedValues[nextStreamId] = value;
  }

  return updatedValues;
}
